import ConfigStore from '../stores/ConfigStore';
import AppDispatcher from '../utils/AppDispatcher';
import Cookies from 'universal-cookie';
import { actions as ActionTypes } from '../constants/AuthConstants';
import AuthApi from '../api/AuthApi';
import UserApi from '../api/UserApi';
import ForgotApi from '../api/ForgotApi';
import AjaxPromises from '../utils/AjaxPromises';
import { endPoints as EndPoints } from '../constants/AuthConstants';
import NotificationActions from './NotificationActions';

// var RSVP = require('rsvp');

export default {

    autoLogin: (data) => {
        const sessionId = data.sessionId;
        const userId    = data.UserId;
        const skipRedirect    = data.skipRedirect;

        return RSVP.all([
            UserApi.getUserDetails({ sessionId : sessionId }),
        ]).then(res => {
            res[0].Data.sessionId = sessionId;

            if(res[0].Data.locations.length > 0) {
                AppDispatcher.dispatch({
                    actionType: ActionTypes.LOGIN,
                    data: res[0].Data,
                    skipRedirect: skipRedirect
                });

                return res[0].Data
            } else {
                NotificationActions.error('User does not have permissions for POS')
                AppDispatcher.dispatch({
                    actionType: ActionTypes.LOGOUT,
                    data: false
                })
            }
        });
    },

    goToDutchieRegister: async (data, showErrorMessages) => {
        try{
            const env = await UserApi.getEnvironmentDetails();

            if(!env.Data) {
                if(showErrorMessages){
                    NotificationActions.error('Error loading dutchie register configuration', false);
                }
                return;
            }

            const url = env.Data.DutchieRegisterUrl || env.Data.Pos4Url;

            data.RegisterId = data.Register;
            const token = await UserApi.generateLoginToken(data);

            window.location = `${url}?dutchie_token=${token.Data}&origin=POS3`;
        }
        catch(e) {
            if(showErrorMessages){
                NotificationActions.error(`Error retrieving dutchie register configuration: ${e}`, false);
            }
            return;
        }
    },

    login:(formData) => {
        var promise = AuthApi.login(formData);

        promise.then(loginResponse => {
            if (!loginResponse.Result) {

                AppDispatcher.dispatch({
                    actionType: ActionTypes.LOGIN,
                    user: loginResponse.Data,
                    data: false
                });
            } else {
                localStorage.setItem('traceparent', loginResponse.Data.TraceId);
                if (loginResponse.Data.Url) {
                    NotificationActions.warn('Your password has expired and must be changed');
                    setTimeout(() => window.location = loginResponse.Data.Url, 2000);
                    return;
                }
                
                var sessionId = loginResponse.Data.SessionGId;
                var userId    = loginResponse.Data.Id;
                UserApi.getUserDetails({ sessionId : sessionId })
                .then(userDetailResponse => {
                    if (!userDetailResponse.Result) {
                        NotificationActions.error(userDetailResponse.Message);
                        AppDispatcher.dispatch({
                            actionType: ActionTypes.LOGOUT,
                            data: false
                        })
                        return;
                    }
                    userDetailResponse.Data.sessionId = sessionId;
                    userDetailResponse.Data.userId    = userId;
                    if(userDetailResponse.Data.locations.length > 0) {
                        if(ConfigStore.useAutoLogin()) {
                            var cookies = new Cookies();
                            cookies.set('LeafLogixSessionInfo', userDetailResponse.Data, { path: '/' });
                        }
    
                        AppDispatcher.dispatch({
                            actionType: ActionTypes.LOGIN,
                            data: userDetailResponse.Data,
                        });
                    } else {
                        NotificationActions.error('User does not have permissions for POS')
                        AppDispatcher.dispatch({
                            actionType: ActionTypes.LOGOUT,
                            data: false
                        })
                    }
                })
            }
        });
    },

    ssologin:(formData) => {
        AuthApi.ssologin(formData).then(res => {
            if (!res.Result) {
                AppDispatcher.dispatch({
                    actionType: ActionTypes.SSO_LOGIN,
                    data: false
                });
            } else if(res.Result) {
                window.location.href = res.Data;
            }
        })
    },

    forgot:(formData) => {
        var promise = ForgotApi.forgot(formData);

        promise.then(res => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.FORGOT,
            })
        })
    },

    logout:() => {
        var cookies = new Cookies();
        sessionStorage.removeItem('llxPOSBannerIsOpen');
        cookies.remove('LeafLogixSessionInfo', { path: '/' });
        AjaxPromises.POST(EndPoints.LOGOUT, {}).then(data => {
            if (data && data.Result && data.Data){
                window.location.href = data.Data;
            } else{
                location.reload();
            }
            
        });
    }
}



// WEBPACK FOOTER //
// ./ui_src/app/actions/AuthActions.jsx